// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageUploader_wrapper__12DI8","selectImage":"ImageUploader_selectImage__1g1Zr","label":"ImageUploader_label__rvftR"};